import React from "react";

import Alert from "@busbud/design-system-components/dist/Alert";
import type { Choices } from "@busbud/int-schemas/lib";

import { useAppContext } from "@app/helpers/hooks";

import { MALE } from "../../constants/passengers";

type Props = {
  className?: string;
  max_seats_rule: number;
  existing_gendered_seats: string[];
  gender: Choices.Gender;
};

const GenderRuleWarningBanner = (props: Props) => {
  const { translator } = useAppContext();
  const { className, max_seats_rule, existing_gendered_seats, gender } = props;
  const formatted_seats = existing_gendered_seats.join(", ");

  const param = {
    max_seats_rule,
    existing_gendered_seats: formatted_seats
  };

  return (
    <Alert severity="notice" className={className} size="sm">
      {gender === MALE
        ? translator.t(
            "!checkout.seat-selection.max-gender-rule-broken-male",
            param
          )
        : translator.t(
            "!checkout.seat-selection.max-gender-rule-broken-female",
            param
          )}
    </Alert>
  );
};

export default GenderRuleWarningBanner;
